import React from "react";

import ukriEpsrcLogo from "/supporters/ukri-epsrc-square-logo.png";
import ukriEsrcLogo from "/supporters/ukri-esrc-square-logo.png";
import ukriAhrcLogo from "/supporters/ukri-ahrc-square-logo.png";
import accelerateLogo from "/supporters/Accelerate_Stacked_Colour-1024x474.png";
import partnerLogo from "/supporters/images.png";
import pentlandLogo from "/supporters/pentland-lancaster-logo.png";

const supporterLogos = [
  { src: ukriEpsrcLogo, alt: "UKRI EPSRC", width: 140, url: "https://www.ukri.org/councils/epsrc/" },
  { src: ukriEsrcLogo, alt: "UKRI ESRC", width: 140, url: "https://www.ukri.org/councils/esrc/" },
  { src: ukriAhrcLogo, alt: "UKRI AHRC", width: 140, url: "https://www.ukri.org/councils/ahrc/" },
  { src: accelerateLogo, alt: "Accelerate Programme", width: 180, url: "https://arcaccelerator.io/" },
  { src: partnerLogo, alt: "Lancaster University Management School", width: 150, url: "https://www.lancaster.ac.uk/lums/" },
  { src: pentlandLogo, alt: "Pentland & Lancaster University", width: 180, url: "https://www.lancaster.ac.uk/pentland/" },
];

export default function Supporters({ className, ...props }) {
  return (
    <section
      className={`w-full border-t border-[rgba(31,76,84,0.08)] bg-white/80 py-12 ${className || ""}`}
      {...props}
    >
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 px-6">
        <span className="eyebrow-muted">
          Supported by
        </span>
        <div className="flex w-full flex-wrap items-center justify-center gap-10 md:gap-16">
          {supporterLogos.map((logo) => (
            <a
              key={logo.alt}
              href={logo.url}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center rounded-2xl border border-[rgba(31,76,84,0.08)] bg-white/80 px-6 py-4 shadow-[0_10px_24px_rgba(15,23,42,0.05)] transition-all hover:border-[rgba(31,76,84,0.15)] hover:shadow-[0_16px_32px_rgba(15,23,42,0.08)]"
              aria-label={`Visit ${logo.alt} website`}
            >
              <img
                src={logo.src}
                alt={logo.alt}
                style={{ maxWidth: `${logo.width}px`, maxHeight: "48px" }}
                className="h-auto object-contain"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
